// extracted by css-extract-rspack-plugin
export default {"cardGridFrame":"IntroSection-module__cardGridFrame__OJ2nI","gridItem":"IntroSection-module__gridItem__zlJsS","logoSuite":"IntroSection-module__logoSuite__curKh"};